// extracted by mini-css-extract-plugin
export default {"wixStudioToolBar":"ZAZYq4","logo":"rWQeek","switcher":"k4KVG4","studio2":"Xd7bc5","studio2Logo":"Eu0vbk","deviceToggle":"m7Qnk0","deviceToggleItem":"ffxN4i","selected":"_V1DTu"};